<template>
  <div>
    <b-button id="show-btn" @click="showModal">{{
      $t("text.paymentConfirmation.openModal")
    }}</b-button>

    <b-modal
      ref="my-modal"
      id="modal1"
      hide-footer
      title="Payment Confirmation"
    >
      <!-- <div class="d-block text-center">
        <h3>Hello From My Modal!</h3>
      </div> -->
      <div class="epump-loader" style="top: 10%; left: 31%">
        <img src="@/assets/img/epump-logo.png" class="epump-loader-logo" />
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  methods: {
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["my-modal"].toggle("#toggle-btn");
    },
  },
};
</script>
